
class HtmlToFormatDetails {
    fileName: string;
    userProfileId?: number;
    height: number;
    width: number;
    scale: number;
    html: string;
}

export {HtmlToFormatDetails}